import { render, staticRenderFns } from "./barcodeScan.vue?vue&type=template&id=5e874276&scoped=true&"
import script from "./barcodeScan.vue?vue&type=script&lang=js&"
export * from "./barcodeScan.vue?vue&type=script&lang=js&"
import style0 from "./barcodeScan.vue?vue&type=style&index=0&id=5e874276&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e874276",
  null
  
)

export default component.exports